import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class PhotoGridService {
  private $dedup: boolean;
  public _dedup: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public dedup: Observable<boolean> = this._dedup.asObservable();

  public _dedupdone: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public dedupdone: Observable<any> = this._dedupdone.asObservable();

  public _preprocessingDone: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public preprocessingDone: Observable<any> = this._preprocessingDone.asObservable();

  public dedupEnabled(isDedupEnabled: boolean) {
    this._dedup.next(isDedupEnabled);
    if (!isDedupEnabled) {
      this.isDeduping(false);
    }
  }

  public cancelDedup() {
    this._dedup.next(false);
    this.isDeduping(false);
  }

  public isDeduping(done: boolean) {
    this._dedupdone.next(done);
  }

  // public isPrepossingDone(done: boolean) {
  //   this._preprocessingDone.next(done);
  // }


}
